// import { Box, CardContent, Typography } from '@mui/material';
// import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
// import PropTypes from 'prop-types';
// import { StyledSalseCard, StypedIconBox } from '../ThemeComponent';

// interface SalesCardProps {
// 	title?: string;
// 	amount?: string;
// 	description?: string;
// 	icon?: React.ReactNode;
// 	cardColor: string;
// 	textColor: string;
// }

// const SalesCard: React.FC<SalesCardProps> = ({
// 	title = 'Total Sales',
// 	amount = '45,231.89',
// 	description = 'Monthly revenue',
// 	cardColor = '#ECF5F5',
// 	icon = <AttachMoneyIcon style={{ color: 'green' }} />,
// 	textColor = '#ECF5F5',
// }) => (
// 	<StyledSalseCard sx={{ background: `${cardColor}`, border: '0px' }}>
// 		<CardContent style={{ padding: '16px', width: '100%' }}>
// 			<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
// 				<Typography variant="h6" component="div" color="#fff">
// 					{title}
// 				</Typography>
// 				<StypedIconBox
// 					style={{ backgroundColor: '#F9F9F9', padding: '8px', borderRadius: '4px' }}
// 				>
// 					{icon}
// 				</StypedIconBox>
// 			</Box>
// 			<Typography variant="h4" sx={{ color: `${textColor}` }}>
// 				{title === 'Total Plans' ? '₹' : null} {amount}
// 			</Typography>
// 			<Typography variant="body2" sx={{ color: '#fff' }}>
// 				{description}
// 			</Typography>
// 		</CardContent>
// 	</StyledSalseCard>
// );

// SalesCard.propTypes = {
// 	title: PropTypes.string,
// 	amount: PropTypes.string,
// 	description: PropTypes.string,
// 	icon: PropTypes.node,
// 	cardColor: PropTypes.string,
// 	textColor: PropTypes.string,
// };

// export default SalesCard;
// =======================================================================================
// =======================================================================================
// =======================================================================================
// =======================================================================================
// =======================================================================================
// =======================================================================================
// =======================================================================================
// =======================================================================================
import React, { useEffect, useRef } from 'react';
import { Box, CardContent, Typography } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { CountUp } from 'countup.js';
import PropTypes from 'prop-types';
import { StyledSalseCard, StypedIconBox } from '../ThemeComponent';

interface SalesCardProps {
	title?: string;
	amount?: string;
	description?: string;
	icon?: React.ReactNode;
	cardColor: string;
	textColor: string;
	url: string;
}

const SalesCard: React.FC<SalesCardProps> = ({
	title = 'Total Sales',
	amount = '45231.89',
	description = 'Monthly revenue',
	cardColor = '#ECF5F5',
	icon = <AttachMoneyIcon style={{ color: 'green' }} />,
	textColor = '#ECF5F5',
	url = '/',
}) => {
	const amountRef = useRef<HTMLSpanElement>(null);

	useEffect(() => {
		if (amountRef.current) {
			const countUp = new CountUp(
				amountRef.current,
				parseFloat(amount.replace(/,/g, '')),
				{ duration: 5 } // Increased duration for slower counting
			);
			if (!countUp.error) {
				countUp.start();
			} else {
				console.error(countUp.error);
			}
		}
	}, [amount]);

	return (
		<StyledSalseCard sx={{ background: `${cardColor}`, border: '0px' }}>
			<CardContent style={{ padding: '16px', width: '100%' }}>
				<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
					<Typography variant="h6" component="div" color="#fff">
						<a href={url} style={{ textDecoration: 'none', color: 'unset' }}>
							{title}
						</a>
					</Typography>
					<a href={url} style={{ textDecoration: 'none', color: 'unset' }}>
						<StypedIconBox
							style={{
								backgroundColor: '#F9F9F9',
								padding: '8px',
								borderRadius: '4px',
							}}
						>
							{icon}
						</StypedIconBox>
					</a>
				</Box>
				<Typography variant="h4" sx={{ color: `${textColor}` }}>
					{/* {title === 'Total Plans' ? '₹' : null} <span ref={amountRef} /> */}
					<span ref={amountRef} />
				</Typography>
				<Typography variant="body2" sx={{ color: '#fff' }}>
					{description}
				</Typography>
			</CardContent>
		</StyledSalseCard>
	);
};

SalesCard.propTypes = {
	title: PropTypes.string,
	amount: PropTypes.string,
	description: PropTypes.string,
	icon: PropTypes.node,
	cardColor: PropTypes.string,
	textColor: PropTypes.string,
	url: PropTypes.string,
};

export default SalesCard;
